/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Admin_Manager_Full_AccessInputs */



/**
* | output |
* | --- |
* | "Admin and Manager roles always have full access to all guides." |
*
* @param {Knp_Guide_Admin_Manager_Full_AccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_admin_manager_full_access = /** @type {((inputs?: Knp_Guide_Admin_Manager_Full_AccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Admin_Manager_Full_AccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les rôles Administrateur et Manager ont toujours un accès complet à tous les guides.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Administratoren und Manager haben stets vollen Zugriff auf alle Leitfäden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I ruoli di amministratore e gestore hanno sempre accesso completo a tutte le guide.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Администраторы и менеджеры всегда имеют полный доступ ко всем руководствам.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los roles de administrador y gerente siempre tienen acceso completo a todas las guías.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("管理员和经理角色始终拥有所有指南的完整访问权限。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("管理者およびマネージャーの役割には、常にすべてのガイドへのフルアクセス権が付与されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एडमिन और मैनेजर पदों पर कार्यरत व्यक्तियों को हमेशा सभी गाइडों तक पूर्ण पहुंच प्राप्त होती है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Os cargos de Administrador e Gerente sempre têm acesso completo a todos os guias.")
	return /** @type {LocalizedString} */ ("Admin and Manager roles always have full access to all guides.")
});